export default __webpack_public_path__ + "static/gitkraken_account1-7edb7563d89a33a331796acba297f166.png";